module.exports = __webpack_public_path__ + "img/exclamation-triangle-fill.c90de079.svg";